(() => {
  'use strict';
  const initialize = () => {
    const root = document.getElementById('crate-scratch-v3');
    const host = root?.querySelector('#crate-v3-native');
    if (!root || !host || root.dataset.layoutRepair === '10') return;
    root.dataset.layoutRepair = '10';
    const photos = [
      'dcf691c7-6519-4b79-a4aa-ded44877317b',
      '4bb4d5a3-9647-4fdd-b690-daa2079e92dd'
    ];
    const controls = 'input,button,select,textarea,iframe,[role="button"],[contenteditable="true"]';
    const repair = () => {
      const form = host.querySelector('form[data-testid="klaviyo-form-UgUN5a"]');
      if (!form) return;
      for (const image of form.querySelectorAll('img')) {
        const sources = [image.currentSrc, image.getAttribute('src'), image.getAttribute('srcset')].filter(Boolean).join(' ');
        if (!photos.some((key) => sources.includes(key))) continue;
        let side = image;
        while (side.parentElement && side.parentElement !== form) side = side.parentElement;
        if (side.parentElement !== form || side.matches(controls) || side.querySelector(controls)) continue;
        side.classList.add('crate-native-photo');
        form.classList.add('crate-native-row');
        for (const column of form.children) {
          if (column === side || column.tagName !== 'DIV' || column.classList.contains('crate-native-photo')) continue;
          column.classList.add('crate-native-content');
        }
      }
    };
    let queued = false;
    const scheduleRepair = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; repair(); });
    };
    const observer = new MutationObserver(scheduleRepair);
    observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    host.addEventListener('load', scheduleRepair, true);
    root.querySelector('#crate-v3-next')?.addEventListener('click', () => {
      repair();
      requestAnimationFrame(() => {
        root.scrollTop = 0;
        root.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    });
    window.addEventListener('pagehide', () => {
      observer.disconnect();
      host.removeEventListener('load', scheduleRepair, true);
    }, { once: true });
    repair();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

